
import {
    Grid,
    Typography,
    Divider,
    Container,
    Dialog,
    DialogTitle,
    IconButton,
} from "@mui/material";
import styled from '@emotion/styled'
import { Close } from '@mui/icons-material'
import moment from 'moment'

const Centered = styled('div')({
    textalign: "center"
})


const CurrentPlan = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
        // margin: theme.spacing(1),
        width: '100%',
        maxWidth: '200px',
        height: theme.spacing(80),
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: '#69d9d4',
        backgroundColor: '#c4edec',
    }
}));

function PlanInfoDrawer({
    visible,
    cancelText,
    onClose,
    initialValues,
    title
}) {
    if (initialValues == undefined)
        initialValues = {
            name: '',
            application_id: '',
            modules: [],
            free_users: '',
            fixed_charge: '',
            max_users: '',
            price_per_user: '',
            currency: '',
            plan_duration: '',
            expiry: '',
            plan_description: '',
            cgst: '',
            sgst: '',
            igst: '',
            applicable_from: '',
            sku_limit: '',
            bill_limit: '',
        }

    return (
        < >
            <Dialog maxWidth='sm' fullWidth anchor='right' backdrop='static' variant="temporary" open={visible} onClose={onClose}>
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Divider my={2} />
                <Container sx={{ padding: 5, }} >
                    <Grid container spacing={1} direction="column">
                        <Grid item>
                            <Grid container sx={{ justifyContent: 'space-between' }}>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Plan Name
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.name}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Application
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.application?.application_name}

                                        </Typography>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Divider sx={{ marginTop: 2 }} />
                        <Grid item>
                            <Grid container sx={{ justifyContent: 'space-between', paddingTop: 5 }}>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Duration
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.plan_duration} Days
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Grid item>
                                            <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                Price
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Grid container alignItems="center" >
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    Rs {initialValues?.price_per_user}
                                                </Typography>
                                                <Typography style={{

                                                    fontWeight: 'bold',
                                                    color: '#065656',
                                                }} variant="caption">&nbsp;/ User</Typography>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Fixed Price
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            Rs {initialValues?.fixed_charge}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Free Users
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.free_users > 0 ? initialValues?.free_users : 0}
                                        </Typography>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Divider sx={{ marginTop: 2 }} />
                        <Grid item>
                            <Grid container sx={{ justifyContent: 'space-between', paddingTop: 5 }}>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Max Users
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.max_users}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Bill Limit
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.bill_limit}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            SKU Limit
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.sku_limit}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            GST
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {initialValues?.igst} %
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider sx={{ marginTop: 2 }} />
                        <Grid item>
                            <Grid container sx={{ justifyContent: 'space-between', paddingTop: 5 }}>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Applicable From
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {moment(new Date(initialValues?.applicable_from)).format("DD-MM-YYYY")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item >
                                    <Grid container alignItems="center" direction="column">
                                        <Typography style={{ fontSize: 12, color: '#065656' }}>
                                            Applicable Till
                                        </Typography>
                                        <Typography
                                            style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                color: '#065656',
                                            }}
                                        >
                                            {moment(new Date(initialValues?.expiry)).format("DD-MM-YYYY")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Container>
            </Dialog>
        </>
    );
}

export default PlanInfoDrawer